export default __webpack_public_path__ + "static/media/aep.30aa8868.svg";